import React, { ReactNode, useContext } from 'react';

export type PageContextModel = {
  showCookieSettings: boolean;
  setShowCookieSettings: (showCookieSettings: boolean) => void;
};

const PageContext = React.createContext<PageContextModel | null>(null);

type Props = {
  children: ReactNode;
  pageContext: Omit<PageContextModel, 'navbar'>;
};

export const PageContextProvider = ({ children, pageContext }: Props) => {
  return <PageContext.Provider value={{ ...pageContext }}>{children}</PageContext.Provider>;
};

export const usePageContext = () => {
  const pageContext = useContext(PageContext);
  if (pageContext === null) {
    throw Error('usePageContext must be used inside a PageContextProvider!');
  }
  return pageContext;
};
